import React, { useEffect, useRef, useState } from 'react';
import './About.css';
import { Award, Users, Clock, Target } from 'lucide-react';

const About = () => {
  const [isVisible, setIsVisible] = useState(false);
  const aboutRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (aboutRef.current) {
      observer.observe(aboutRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const features = [
    {
      icon: <Award size={32} />,
      title: 'Award Winning',
      description: 'Recognized for excellence in digital innovation',
    },
    {
      icon: <Users size={32} />,
      title: 'Expert Team',
      description: 'Talented professionals dedicated to your success',
    },
    {
      icon: <Clock size={32} />,
      title: '24/7 Support',
      description: 'Always here when you need us',
    },
    {
      icon: <Target size={32} />,
      title: 'Result Driven',
      description: 'Focused on delivering measurable outcomes',
    },
  ];

  return (
    <section className="about-section" id="about" ref={aboutRef}>
      <div className="about-container">
        <div className="about-content">
          <div className={`about-left ${isVisible ? 'visible' : ''}`}>
           
            <h2 className="section-title">About KyroTech</h2>
            <p className="about-text">
              We are a full-service digital agency committed to transforming businesses
              through innovative technology solutions. With a passion for excellence and
              a track record of success, we partner with clients to bring their visions
              to life.
            </p>
            <p className="about-text">
              Our team of experts combines creativity, technical expertise, and strategic
              thinking to deliver solutions that not only meet but exceed expectations.
              From startups to enterprises, we scale our services to fit your unique needs.
            </p>
            <div className="about-cta">
              <button className="btn-learn-more" onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}>
                Let's Talk
              </button>
            </div>
          </div>

          <div className={`about-right ${isVisible ? 'visible' : ''}`}>
            <div className="features-grid">
              {features.map((feature, index) => (
                <div 
                  key={index} 
                  className="feature-card"
                  style={{ animationDelay: `${index * 0.1}s` }}
                >
                  <div className="feature-icon">{feature.icon}</div>
                  <h3 className="feature-title">{feature.title}</h3>
                  <p className="feature-description">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
